var _regeneratorRuntime = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["children"];

(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("streamr-client"));else if (typeof define === 'function' && define.amd) define(["react", "streamr-client"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("streamr-client")) : factory(root["react"], root["streamr-client"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(this, function (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_streamr_client__) {
  return (
    /******/
    function () {
      // webpackBootstrap

      /******/
      var __webpack_modules__ = {
        /***/
        "./node_modules/call-bind/callBound.js": function node_modulesCallBindCallBoundJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var GetIntrinsic = __webpack_require__(
          /*! get-intrinsic */
          "./node_modules/get-intrinsic/index.js");

          var callBind = __webpack_require__(
          /*! ./ */
          "./node_modules/call-bind/index.js");

          var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

          module.exports = function callBoundIntrinsic(name, allowMissing) {
            var intrinsic = GetIntrinsic(name, !!allowMissing);

            if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
              return callBind(intrinsic);
            }

            return intrinsic;
          };
          /***/

        },

        /***/
        "./node_modules/call-bind/index.js": function node_modulesCallBindIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var bind = __webpack_require__(
          /*! function-bind */
          "./node_modules/function-bind/index.js");

          var GetIntrinsic = __webpack_require__(
          /*! get-intrinsic */
          "./node_modules/get-intrinsic/index.js");

          var $apply = GetIntrinsic('%Function.prototype.apply%');
          var $call = GetIntrinsic('%Function.prototype.call%');
          var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
          var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
          var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
          var $max = GetIntrinsic('%Math.max%');

          if ($defineProperty) {
            try {
              $defineProperty({}, 'a', {
                value: 1
              });
            } catch (e) {
              // IE 8 has a broken defineProperty
              $defineProperty = null;
            }
          }

          module.exports = function callBind(originalFunction) {
            var func = $reflectApply(bind, $call, arguments);

            if ($gOPD && $defineProperty) {
              var desc = $gOPD(func, 'length');

              if (desc.configurable) {
                // original length, plus the receiver, minus any additional arguments (after the receiver)
                $defineProperty(func, 'length', {
                  value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
                });
              }
            }

            return func;
          };

          var applyBind = function applyBind() {
            return $reflectApply(bind, $apply, arguments);
          };

          if ($defineProperty) {
            $defineProperty(module.exports, 'apply', {
              value: applyBind
            });
          } else {
            module.exports.apply = applyBind;
          }
          /***/

        },

        /***/
        "./node_modules/deep-equal/index.js": function node_modulesDeepEqualIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var objectKeys = __webpack_require__(
          /*! object-keys */
          "./node_modules/object-keys/index.js");

          var isArguments = __webpack_require__(
          /*! is-arguments */
          "./node_modules/is-arguments/index.js");

          var is = __webpack_require__(
          /*! object-is */
          "./node_modules/object-is/index.js");

          var isRegex = __webpack_require__(
          /*! is-regex */
          "./node_modules/is-regex/index.js");

          var flags = __webpack_require__(
          /*! regexp.prototype.flags */
          "./node_modules/regexp.prototype.flags/index.js");

          var isArray = __webpack_require__(
          /*! isarray */
          "./node_modules/deep-equal/node_modules/isarray/index.js");

          var isDate = __webpack_require__(
          /*! is-date-object */
          "./node_modules/is-date-object/index.js");

          var whichBoxedPrimitive = __webpack_require__(
          /*! which-boxed-primitive */
          "./node_modules/which-boxed-primitive/index.js");

          var GetIntrinsic = __webpack_require__(
          /*! get-intrinsic */
          "./node_modules/get-intrinsic/index.js");

          var callBound = __webpack_require__(
          /*! call-bind/callBound */
          "./node_modules/call-bind/callBound.js");

          var whichCollection = __webpack_require__(
          /*! which-collection */
          "./node_modules/which-collection/index.js");

          var getIterator = __webpack_require__(
          /*! es-get-iterator */
          "./node_modules/es-get-iterator/index.js");

          var getSideChannel = __webpack_require__(
          /*! side-channel */
          "./node_modules/side-channel/index.js");

          var whichTypedArray = __webpack_require__(
          /*! which-typed-array */
          "./node_modules/which-typed-array/index.js");

          var assign = __webpack_require__(
          /*! object.assign */
          "./node_modules/object.assign/index.js");

          var $getTime = callBound('Date.prototype.getTime');
          var gPO = Object.getPrototypeOf;
          var $objToString = callBound('Object.prototype.toString');
          var $Set = GetIntrinsic('%Set%', true);
          var $mapHas = callBound('Map.prototype.has', true);
          var $mapGet = callBound('Map.prototype.get', true);
          var $mapSize = callBound('Map.prototype.size', true);
          var $setAdd = callBound('Set.prototype.add', true);
          var $setDelete = callBound('Set.prototype.delete', true);
          var $setHas = callBound('Set.prototype.has', true);
          var $setSize = callBound('Set.prototype.size', true); // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414

          function setHasEqualElement(set, val1, opts, channel) {
            var i = getIterator(set);
            var result;

            while ((result = i.next()) && !result.done) {
              if (internalDeepEqual(val1, result.value, opts, channel)) {
                // eslint-disable-line no-use-before-define
                // Remove the matching element to make sure we do not check that again.
                $setDelete(set, result.value);
                return true;
              }
            }

            return false;
          } // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439


          function findLooseMatchingPrimitives(prim) {
            if (typeof prim === 'undefined') {
              return null;
            }

            if (typeof prim === 'object') {
              // Only pass in null as object!
              return void 0;
            }

            if (typeof prim === 'symbol') {
              return false;
            }

            if (typeof prim === 'string' || typeof prim === 'number') {
              // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
              return +prim === +prim; // eslint-disable-line no-implicit-coercion
            }

            return true;
          } // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460


          function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
            var altValue = findLooseMatchingPrimitives(prim);

            if (altValue != null) {
              return altValue;
            }

            var curB = $mapGet(b, altValue);
            var looseOpts = assign({}, opts, {
              strict: false
            });

            if (typeof curB === 'undefined' && !$mapHas(b, altValue) || !internalDeepEqual(item, curB, looseOpts, channel)) {
              return false;
            } // eslint-disable-next-line no-use-before-define


            return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
          } // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447


          function setMightHaveLoosePrim(a, b, prim) {
            var altValue = findLooseMatchingPrimitives(prim);

            if (altValue != null) {
              return altValue;
            }

            return $setHas(b, altValue) && !$setHas(a, altValue);
          } // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533


          function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
            var i = getIterator(set);
            var result;
            var key2;

            while ((result = i.next()) && !result.done) {
              key2 = result.value;

              if ( // eslint-disable-next-line no-use-before-define
              internalDeepEqual(key1, key2, opts, channel) // eslint-disable-next-line no-use-before-define
              && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)) {
                $setDelete(set, key2);
                return true;
              }
            }

            return false;
          }

          function internalDeepEqual(actual, expected, options, channel) {
            var opts = options || {}; // 7.1. All identical values are equivalent, as determined by ===.

            if (opts.strict ? is(actual, expected) : actual === expected) {
              return true;
            }

            var actualBoxed = whichBoxedPrimitive(actual);
            var expectedBoxed = whichBoxedPrimitive(expected);

            if (actualBoxed !== expectedBoxed) {
              return false;
            } // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.


            if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') {
              return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
            }
            /*
             * 7.4. For all other Object pairs, including Array objects, equivalence is
             * determined by having the same number of owned properties (as verified
             * with Object.prototype.hasOwnProperty.call), the same set of keys
             * (although not necessarily the same order), equivalent values for every
             * corresponding key, and an identical 'prototype' property. Note: this
             * accounts for both named and indexed properties on Arrays.
             */
            // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration


            var hasActual = channel.has(actual);
            var hasExpected = channel.has(expected);
            var sentinel;

            if (hasActual && hasExpected) {
              if (channel.get(actual) === channel.get(expected)) {
                return true;
              }
            } else {
              sentinel = {};
            }

            if (!hasActual) {
              channel.set(actual, sentinel);
            }

            if (!hasExpected) {
              channel.set(expected, sentinel);
            } // eslint-disable-next-line no-use-before-define


            return objEquiv(actual, expected, opts, channel);
          }

          function isBuffer(x) {
            if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
              return false;
            }

            if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
              return false;
            }

            if (x.length > 0 && typeof x[0] !== 'number') {
              return false;
            }

            return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
          }

          function setEquiv(a, b, opts, channel) {
            if ($setSize(a) !== $setSize(b)) {
              return false;
            }

            var iA = getIterator(a);
            var iB = getIterator(b);
            var resultA;
            var resultB;
            var set;

            while ((resultA = iA.next()) && !resultA.done) {
              if (resultA.value && typeof resultA.value === 'object') {
                if (!set) {
                  set = new $Set();
                }

                $setAdd(set, resultA.value);
              } else if (!$setHas(b, resultA.value)) {
                if (opts.strict) {
                  return false;
                }

                if (!setMightHaveLoosePrim(a, b, resultA.value)) {
                  return false;
                }

                if (!set) {
                  set = new $Set();
                }

                $setAdd(set, resultA.value);
              }
            }

            if (set) {
              while ((resultB = iB.next()) && !resultB.done) {
                // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
                if (resultB.value && typeof resultB.value === 'object') {
                  if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
                    return false;
                  }
                } else if (!opts.strict && !$setHas(a, resultB.value) && !setHasEqualElement(set, resultB.value, opts.strict, channel)) {
                  return false;
                }
              }

              return $setSize(set) === 0;
            }

            return true;
          }

          function mapEquiv(a, b, opts, channel) {
            if ($mapSize(a) !== $mapSize(b)) {
              return false;
            }

            var iA = getIterator(a);
            var iB = getIterator(b);
            var resultA;
            var resultB;
            var set;
            var key;
            var item1;
            var item2;

            while ((resultA = iA.next()) && !resultA.done) {
              key = resultA.value[0];
              item1 = resultA.value[1];

              if (key && typeof key === 'object') {
                if (!set) {
                  set = new $Set();
                }

                $setAdd(set, key);
              } else {
                item2 = $mapGet(b, key);

                if (typeof item2 === 'undefined' && !$mapHas(b, key) || !internalDeepEqual(item1, item2, opts, channel)) {
                  if (opts.strict) {
                    return false;
                  }

                  if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
                    return false;
                  }

                  if (!set) {
                    set = new $Set();
                  }

                  $setAdd(set, key);
                }
              }
            }

            if (set) {
              while ((resultB = iB.next()) && !resultB.done) {
                key = resultB.value[0];
                item2 = resultB.value[1];

                if (key && typeof key === 'object') {
                  if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
                    return false;
                  }
                } else if (!opts.strict && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel)) && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, {
                  strict: false
                }), channel)) {
                  return false;
                }
              }

              return $setSize(set) === 0;
            }

            return true;
          }

          function objEquiv(a, b, opts, channel) {
            /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5] */
            var i, key;

            if (typeof a !== typeof b) {
              return false;
            }

            if (a == null || b == null) {
              return false;
            }

            if ($objToString(a) !== $objToString(b)) {
              return false;
            }

            if (isArguments(a) !== isArguments(b)) {
              return false;
            }

            var aIsArray = isArray(a);
            var bIsArray = isArray(b);

            if (aIsArray !== bIsArray) {
              return false;
            } // TODO: replace when a cross-realm brand check is available


            var aIsError = a instanceof Error;
            var bIsError = b instanceof Error;

            if (aIsError !== bIsError) {
              return false;
            }

            if (aIsError || bIsError) {
              if (a.name !== b.name || a.message !== b.message) {
                return false;
              }
            }

            var aIsRegex = isRegex(a);
            var bIsRegex = isRegex(b);

            if (aIsRegex !== bIsRegex) {
              return false;
            }

            if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
              return false;
            }

            var aIsDate = isDate(a);
            var bIsDate = isDate(b);

            if (aIsDate !== bIsDate) {
              return false;
            }

            if (aIsDate || bIsDate) {
              // && would work too, because both are true or both false here
              if ($getTime(a) !== $getTime(b)) {
                return false;
              }
            }

            if (opts.strict && gPO && gPO(a) !== gPO(b)) {
              return false;
            }

            if (whichTypedArray(a) !== whichTypedArray(b)) {
              return false;
            }

            var aIsBuffer = isBuffer(a);
            var bIsBuffer = isBuffer(b);

            if (aIsBuffer !== bIsBuffer) {
              return false;
            }

            if (aIsBuffer || bIsBuffer) {
              // && would work too, because both are true or both false here
              if (a.length !== b.length) {
                return false;
              }

              for (i = 0; i < a.length; i++) {
                if (a[i] !== b[i]) {
                  return false;
                }
              }

              return true;
            }

            if (typeof a !== typeof b) {
              return false;
            }

            var ka = objectKeys(a);
            var kb = objectKeys(b); // having the same number of owned properties (keys incorporates hasOwnProperty)

            if (ka.length !== kb.length) {
              return false;
            } // the same set of keys (although not necessarily the same order),


            ka.sort();
            kb.sort(); // ~~~cheap key test

            for (i = ka.length - 1; i >= 0; i--) {
              if (ka[i] != kb[i]) {
                return false;
              } // eslint-disable-line eqeqeq

            } // equivalent values for every corresponding key, and ~~~possibly expensive deep test


            for (i = ka.length - 1; i >= 0; i--) {
              key = ka[i];

              if (!internalDeepEqual(a[key], b[key], opts, channel)) {
                return false;
              }
            }

            var aCollection = whichCollection(a);
            var bCollection = whichCollection(b);

            if (aCollection !== bCollection) {
              return false;
            }

            if (aCollection === 'Set' || bCollection === 'Set') {
              // aCollection === bCollection
              return setEquiv(a, b, opts, channel);
            }

            if (aCollection === 'Map') {
              // aCollection === bCollection
              return mapEquiv(a, b, opts, channel);
            }

            return true;
          }

          module.exports = function deepEqual(a, b, opts) {
            return internalDeepEqual(a, b, opts, getSideChannel());
          };
          /***/

        },

        /***/
        "./node_modules/deep-equal/node_modules/isarray/index.js": function node_modulesDeepEqualNode_modulesIsarrayIndexJs(module) {
          var toString = {}.toString;

          module.exports = Array.isArray || function (arr) {
            return toString.call(arr) == '[object Array]';
          };
          /***/

        },

        /***/
        "./node_modules/define-properties/index.js": function node_modulesDefinePropertiesIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var keys = __webpack_require__(
          /*! object-keys */
          "./node_modules/object-keys/index.js");

          var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
          var toStr = Object.prototype.toString;
          var concat = Array.prototype.concat;
          var origDefineProperty = Object.defineProperty;

          var isFunction = function isFunction(fn) {
            return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
          };

          var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
            var obj = {};

            try {
              origDefineProperty(obj, 'x', {
                enumerable: false,
                value: obj
              }); // eslint-disable-next-line no-unused-vars, no-restricted-syntax

              for (var _ in obj) {
                // jscs:ignore disallowUnusedVariables
                return false;
              }

              return obj.x === obj;
            } catch (e) {
              /* this is IE 8. */
              return false;
            }
          };

          var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

          var defineProperty = function defineProperty(object, name, value, predicate) {
            if (name in object && (!isFunction(predicate) || !predicate())) {
              return;
            }

            if (supportsDescriptors) {
              origDefineProperty(object, name, {
                configurable: true,
                enumerable: false,
                value: value,
                writable: true
              });
            } else {
              object[name] = value;
            }
          };

          var defineProperties = function defineProperties(object, map) {
            var predicates = arguments.length > 2 ? arguments[2] : {};
            var props = keys(map);

            if (hasSymbols) {
              props = concat.call(props, Object.getOwnPropertySymbols(map));
            }

            for (var i = 0; i < props.length; i += 1) {
              defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
            }
          };

          defineProperties.supportsDescriptors = !!supportsDescriptors;
          module.exports = defineProperties;
          /***/
        },

        /***/
        "./node_modules/es-get-iterator/node_modules/isarray/index.js": function node_modulesEsGetIteratorNode_modulesIsarrayIndexJs(module) {
          var toString = {}.toString;

          module.exports = Array.isArray || function (arr) {
            return toString.call(arr) == '[object Array]';
          };
          /***/

        },

        /***/
        "./node_modules/foreach/index.js": function node_modulesForeachIndexJs(module) {
          var hasOwn = Object.prototype.hasOwnProperty;
          var toString = Object.prototype.toString;

          module.exports = function forEach(obj, fn, ctx) {
            if (toString.call(fn) !== '[object Function]') {
              throw new TypeError('iterator must be a function');
            }

            var l = obj.length;

            if (l === +l) {
              for (var i = 0; i < l; i++) {
                fn.call(ctx, obj[i], i, obj);
              }
            } else {
              for (var k in obj) {
                if (hasOwn.call(obj, k)) {
                  fn.call(ctx, obj[k], k, obj);
                }
              }
            }
          };
          /***/

        },

        /***/
        "./node_modules/function-bind/implementation.js": function node_modulesFunctionBindImplementationJs(module) {
          "use strict";
          /* eslint no-invalid-this: 1 */

          var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
          var slice = Array.prototype.slice;
          var toStr = Object.prototype.toString;
          var funcType = '[object Function]';

          module.exports = function bind(that) {
            var target = this;

            if (typeof target !== 'function' || toStr.call(target) !== funcType) {
              throw new TypeError(ERROR_MESSAGE + target);
            }

            var args = slice.call(arguments, 1);
            var bound;

            var binder = function binder() {
              if (this instanceof bound) {
                var result = target.apply(this, args.concat(slice.call(arguments)));

                if (Object(result) === result) {
                  return result;
                }

                return this;
              } else {
                return target.apply(that, args.concat(slice.call(arguments)));
              }
            };

            var boundLength = Math.max(0, target.length - args.length);
            var boundArgs = [];

            for (var i = 0; i < boundLength; i++) {
              boundArgs.push('$' + i);
            }

            bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

            if (target.prototype) {
              var Empty = function Empty() {};

              Empty.prototype = target.prototype;
              bound.prototype = new Empty();
              Empty.prototype = null;
            }

            return bound;
          };
          /***/

        },

        /***/
        "./node_modules/function-bind/index.js": function node_modulesFunctionBindIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var implementation = __webpack_require__(
          /*! ./implementation */
          "./node_modules/function-bind/implementation.js");

          module.exports = Function.prototype.bind || implementation;
          /***/
        },

        /***/
        "./node_modules/get-intrinsic/index.js": function node_modulesGetIntrinsicIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var undefined;
          var $SyntaxError = SyntaxError;
          var $Function = Function;
          var $TypeError = TypeError; // eslint-disable-next-line consistent-return

          var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
            try {
              return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
            } catch (e) {}
          };

          var $gOPD = Object.getOwnPropertyDescriptor;

          if ($gOPD) {
            try {
              $gOPD({}, '');
            } catch (e) {
              $gOPD = null; // this is IE 8, which has a broken gOPD
            }
          }

          var throwTypeError = function throwTypeError() {
            throw new $TypeError();
          };

          var ThrowTypeError = $gOPD ? function () {
            try {
              // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
              arguments.callee; // IE 8 does not throw here

              return throwTypeError;
            } catch (calleeThrows) {
              try {
                // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
                return $gOPD(arguments, 'callee').get;
              } catch (gOPDthrows) {
                return throwTypeError;
              }
            }
          }() : throwTypeError;

          var hasSymbols = __webpack_require__(
          /*! has-symbols */
          "./node_modules/has-symbols/index.js")();

          var getProto = Object.getPrototypeOf || function (x) {
            return x.__proto__;
          }; // eslint-disable-line no-proto


          var needsEval = {};
          var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
          var INTRINSICS = {
            '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
            '%Array%': Array,
            '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
            '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
            '%AsyncFromSyncIteratorPrototype%': undefined,
            '%AsyncFunction%': needsEval,
            '%AsyncGenerator%': needsEval,
            '%AsyncGeneratorFunction%': needsEval,
            '%AsyncIteratorPrototype%': needsEval,
            '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
            '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
            '%Boolean%': Boolean,
            '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
            '%Date%': Date,
            '%decodeURI%': decodeURI,
            '%decodeURIComponent%': decodeURIComponent,
            '%encodeURI%': encodeURI,
            '%encodeURIComponent%': encodeURIComponent,
            '%Error%': Error,
            '%eval%': eval,
            // eslint-disable-line no-eval
            '%EvalError%': EvalError,
            '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
            '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
            '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
            '%Function%': $Function,
            '%GeneratorFunction%': needsEval,
            '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
            '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
            '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
            '%isFinite%': isFinite,
            '%isNaN%': isNaN,
            '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
            '%JSON%': typeof JSON === 'object' ? JSON : undefined,
            '%Map%': typeof Map === 'undefined' ? undefined : Map,
            '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
            '%Math%': Math,
            '%Number%': Number,
            '%Object%': Object,
            '%parseFloat%': parseFloat,
            '%parseInt%': parseInt,
            '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
            '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
            '%RangeError%': RangeError,
            '%ReferenceError%': ReferenceError,
            '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
            '%RegExp%': RegExp,
            '%Set%': typeof Set === 'undefined' ? undefined : Set,
            '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
            '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
            '%String%': String,
            '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
            '%Symbol%': hasSymbols ? Symbol : undefined,
            '%SyntaxError%': $SyntaxError,
            '%ThrowTypeError%': ThrowTypeError,
            '%TypedArray%': TypedArray,
            '%TypeError%': $TypeError,
            '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
            '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
            '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
            '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
            '%URIError%': URIError,
            '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
            '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
            '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
          };

          var doEval = function doEval(name) {
            var value;

            if (name === '%AsyncFunction%') {
              value = getEvalledConstructor('async function () {}');
            } else if (name === '%GeneratorFunction%') {
              value = getEvalledConstructor('function* () {}');
            } else if (name === '%AsyncGeneratorFunction%') {
              value = getEvalledConstructor('async function* () {}');
            } else if (name === '%AsyncGenerator%') {
              var fn = doEval('%AsyncGeneratorFunction%');

              if (fn) {
                value = fn.prototype;
              }
            } else if (name === '%AsyncIteratorPrototype%') {
              var gen = doEval('%AsyncGenerator%');

              if (gen) {
                value = getProto(gen.prototype);
              }
            }

            INTRINSICS[name] = value;
            return value;
          };

          var LEGACY_ALIASES = {
            '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
            '%ArrayPrototype%': ['Array', 'prototype'],
            '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
            '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
            '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
            '%ArrayProto_values%': ['Array', 'prototype', 'values'],
            '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
            '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
            '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
            '%BooleanPrototype%': ['Boolean', 'prototype'],
            '%DataViewPrototype%': ['DataView', 'prototype'],
            '%DatePrototype%': ['Date', 'prototype'],
            '%ErrorPrototype%': ['Error', 'prototype'],
            '%EvalErrorPrototype%': ['EvalError', 'prototype'],
            '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
            '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
            '%FunctionPrototype%': ['Function', 'prototype'],
            '%Generator%': ['GeneratorFunction', 'prototype'],
            '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
            '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
            '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
            '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
            '%JSONParse%': ['JSON', 'parse'],
            '%JSONStringify%': ['JSON', 'stringify'],
            '%MapPrototype%': ['Map', 'prototype'],
            '%NumberPrototype%': ['Number', 'prototype'],
            '%ObjectPrototype%': ['Object', 'prototype'],
            '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
            '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
            '%PromisePrototype%': ['Promise', 'prototype'],
            '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
            '%Promise_all%': ['Promise', 'all'],
            '%Promise_reject%': ['Promise', 'reject'],
            '%Promise_resolve%': ['Promise', 'resolve'],
            '%RangeErrorPrototype%': ['RangeError', 'prototype'],
            '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
            '%RegExpPrototype%': ['RegExp', 'prototype'],
            '%SetPrototype%': ['Set', 'prototype'],
            '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
            '%StringPrototype%': ['String', 'prototype'],
            '%SymbolPrototype%': ['Symbol', 'prototype'],
            '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
            '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
            '%TypeErrorPrototype%': ['TypeError', 'prototype'],
            '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
            '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
            '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
            '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
            '%URIErrorPrototype%': ['URIError', 'prototype'],
            '%WeakMapPrototype%': ['WeakMap', 'prototype'],
            '%WeakSetPrototype%': ['WeakSet', 'prototype']
          };

          var bind = __webpack_require__(
          /*! function-bind */
          "./node_modules/function-bind/index.js");

          var hasOwn = __webpack_require__(
          /*! has */
          "./node_modules/has/src/index.js");

          var $concat = bind.call(Function.call, Array.prototype.concat);
          var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
          var $replace = bind.call(Function.call, String.prototype.replace);
          var $strSlice = bind.call(Function.call, String.prototype.slice);
          /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */

          var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
          var reEscapeChar = /\\(\\)?/g;
          /** Used to match backslashes in property paths. */

          var stringToPath = function stringToPath(string) {
            var first = $strSlice(string, 0, 1);
            var last = $strSlice(string, -1);

            if (first === '%' && last !== '%') {
              throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
            } else if (last === '%' && first !== '%') {
              throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
            }

            var result = [];
            $replace(string, rePropName, function (match, number, quote, subString) {
              result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
            });
            return result;
          };
          /* end adaptation */


          var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
            var intrinsicName = name;
            var alias;

            if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
              alias = LEGACY_ALIASES[intrinsicName];
              intrinsicName = '%' + alias[0] + '%';
            }

            if (hasOwn(INTRINSICS, intrinsicName)) {
              var value = INTRINSICS[intrinsicName];

              if (value === needsEval) {
                value = doEval(intrinsicName);
              }

              if (typeof value === 'undefined' && !allowMissing) {
                throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
              }

              return {
                alias: alias,
                name: intrinsicName,
                value: value
              };
            }

            throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
          };

          module.exports = function GetIntrinsic(name, allowMissing) {
            if (typeof name !== 'string' || name.length === 0) {
              throw new $TypeError('intrinsic name must be a non-empty string');
            }

            if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
              throw new $TypeError('"allowMissing" argument must be a boolean');
            }

            var parts = stringToPath(name);
            var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
            var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
            var intrinsicRealName = intrinsic.name;
            var value = intrinsic.value;
            var skipFurtherCaching = false;
            var alias = intrinsic.alias;

            if (alias) {
              intrinsicBaseName = alias[0];
              $spliceApply(parts, $concat([0, 1], alias));
            }

            for (var i = 1, isOwn = true; i < parts.length; i += 1) {
              var part = parts[i];
              var first = $strSlice(part, 0, 1);
              var last = $strSlice(part, -1);

              if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
                throw new $SyntaxError('property names with quotes must have matching quotes');
              }

              if (part === 'constructor' || !isOwn) {
                skipFurtherCaching = true;
              }

              intrinsicBaseName += '.' + part;
              intrinsicRealName = '%' + intrinsicBaseName + '%';

              if (hasOwn(INTRINSICS, intrinsicRealName)) {
                value = INTRINSICS[intrinsicRealName];
              } else if (value != null) {
                if (!(part in value)) {
                  if (!allowMissing) {
                    throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                  }

                  return void undefined;
                }

                if ($gOPD && i + 1 >= parts.length) {
                  var desc = $gOPD(value, part);
                  isOwn = !!desc; // By convention, when a data property is converted to an accessor
                  // property to emulate a data property that does not suffer from
                  // the override mistake, that accessor's getter is marked with
                  // an `originalValue` property. Here, when we detect this, we
                  // uphold the illusion by pretending to see that original data
                  // property, i.e., returning the value rather than the getter
                  // itself.

                  if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
                    value = desc.get;
                  } else {
                    value = value[part];
                  }
                } else {
                  isOwn = hasOwn(value, part);
                  value = value[part];
                }

                if (isOwn && !skipFurtherCaching) {
                  INTRINSICS[intrinsicRealName] = value;
                }
              }
            }

            return value;
          };
          /***/

        },

        /***/
        "./node_modules/has-symbols/index.js": function node_modulesHasSymbolsIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var origSymbol = __webpack_require__.g.Symbol;

          var hasSymbolSham = __webpack_require__(
          /*! ./shams */
          "./node_modules/has-symbols/shams.js");

          module.exports = function hasNativeSymbols() {
            if (typeof origSymbol !== 'function') {
              return false;
            }

            if (typeof Symbol !== 'function') {
              return false;
            }

            if (typeof origSymbol('foo') !== 'symbol') {
              return false;
            }

            if (typeof Symbol('bar') !== 'symbol') {
              return false;
            }

            return hasSymbolSham();
          };
          /***/

        },

        /***/
        "./node_modules/has-symbols/shams.js": function node_modulesHasSymbolsShamsJs(module) {
          "use strict";
          /* eslint complexity: [2, 18], max-statements: [2, 33] */

          module.exports = function hasSymbols() {
            if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
              return false;
            }

            if (typeof Symbol.iterator === 'symbol') {
              return true;
            }

            var obj = {};
            var sym = Symbol('test');
            var symObj = Object(sym);

            if (typeof sym === 'string') {
              return false;
            }

            if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
              return false;
            }

            if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
              return false;
            } // temp disabled per https://github.com/ljharb/object.assign/issues/17
            // if (sym instanceof Symbol) { return false; }
            // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
            // if (!(symObj instanceof Symbol)) { return false; }
            // if (typeof Symbol.prototype.toString !== 'function') { return false; }
            // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }


            var symVal = 42;
            obj[sym] = symVal;

            for (sym in obj) {
              return false;
            } // eslint-disable-line no-restricted-syntax


            if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
              return false;
            }

            if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
              return false;
            }

            var syms = Object.getOwnPropertySymbols(obj);

            if (syms.length !== 1 || syms[0] !== sym) {
              return false;
            }

            if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
              return false;
            }

            if (typeof Object.getOwnPropertyDescriptor === 'function') {
              var descriptor = Object.getOwnPropertyDescriptor(obj, sym);

              if (descriptor.value !== symVal || descriptor.enumerable !== true) {
                return false;
              }
            }

            return true;
          };
          /***/

        },

        /***/
        "./node_modules/has/src/index.js": function node_modulesHasSrcIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var bind = __webpack_require__(
          /*! function-bind */
          "./node_modules/function-bind/index.js");

          module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
          /***/
        },

        /***/
        "./node_modules/is-arguments/index.js": function node_modulesIsArgumentsIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

          var callBound = __webpack_require__(
          /*! call-bind/callBound */
          "./node_modules/call-bind/callBound.js");

          var $toString = callBound('Object.prototype.toString');

          var isStandardArguments = function isArguments(value) {
            if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
              return false;
            }

            return $toString(value) === '[object Arguments]';
          };

          var isLegacyArguments = function isArguments(value) {
            if (isStandardArguments(value)) {
              return true;
            }

            return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && $toString(value.callee) === '[object Function]';
          };

          var supportsStandardArguments = function () {
            return isStandardArguments(arguments);
          }();

          isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

          module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
          /***/
        },

        /***/
        "./node_modules/is-bigint/index.js": function node_modulesIsBigintIndexJs(module) {
          "use strict";

          if (typeof BigInt === 'function') {
            var bigIntValueOf = BigInt.prototype.valueOf;

            var tryBigInt = function tryBigIntObject(value) {
              try {
                bigIntValueOf.call(value);
                return true;
              } catch (e) {}

              return false;
            };

            module.exports = function isBigInt(value) {
              if (value === null || typeof value === 'undefined' || typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number' || typeof value === 'symbol' || typeof value === 'function') {
                return false;
              }

              if (typeof value === 'bigint') {
                return true;
              }

              return tryBigInt(value);
            };
          } else {
            module.exports = function isBigInt(value) {
              return false && 0;
            };
          }
          /***/

        },

        /***/
        "./node_modules/is-boolean-object/index.js": function node_modulesIsBooleanObjectIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var callBound = __webpack_require__(
          /*! call-bind/callBound */
          "./node_modules/call-bind/callBound.js");

          var $boolToStr = callBound('Boolean.prototype.toString');
          var $toString = callBound('Object.prototype.toString');

          var tryBooleanObject = function booleanBrandCheck(value) {
            try {
              $boolToStr(value);
              return true;
            } catch (e) {
              return false;
            }
          };

          var boolClass = '[object Boolean]';
          var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;

          module.exports = function isBoolean(value) {
            if (typeof value === 'boolean') {
              return true;
            }

            if (value === null || typeof value !== 'object') {
              return false;
            }

            return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
          };
          /***/

        },

        /***/
        "./node_modules/is-date-object/index.js": function node_modulesIsDateObjectIndexJs(module) {
          "use strict";

          var getDay = Date.prototype.getDay;

          var tryDateObject = function tryDateGetDayCall(value) {
            try {
              getDay.call(value);
              return true;
            } catch (e) {
              return false;
            }
          };

          var toStr = Object.prototype.toString;
          var dateClass = '[object Date]';
          var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

          module.exports = function isDateObject(value) {
            if (typeof value !== 'object' || value === null) {
              return false;
            }

            return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
          };
          /***/

        },

        /***/
        "./node_modules/is-map/index.js": function node_modulesIsMapIndexJs(module) {
          "use strict";

          var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
          var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
          var exported;

          if (!$Map) {
            // eslint-disable-next-line no-unused-vars
            exported = function isMap(x) {
              // `Map` is not present in this environment.
              return false;
            };
          }

          var $mapHas = $Map ? Map.prototype.has : null;
          var $setHas = $Set ? Set.prototype.has : null;

          if (!exported && !$mapHas) {
            // eslint-disable-next-line no-unused-vars
            exported = function isMap(x) {
              // `Map` does not have a `has` method
              return false;
            };
          }

          module.exports = exported || function isMap(x) {
            if (!x || typeof x !== 'object') {
              return false;
            }

            try {
              $mapHas.call(x);

              if ($setHas) {
                try {
                  $setHas.call(x);
                } catch (e) {
                  return true;
                }
              }

              return x instanceof $Map; // core-js workaround, pre-v2.5.0
            } catch (e) {}

            return false;
          };
          /***/

        },

        /***/
        "./node_modules/is-number-object/index.js": function node_modulesIsNumberObjectIndexJs(module) {
          "use strict";

          var numToStr = Number.prototype.toString;

          var tryNumberObject = function tryNumberObject(value) {
            try {
              numToStr.call(value);
              return true;
            } catch (e) {
              return false;
            }
          };

          var toStr = Object.prototype.toString;
          var numClass = '[object Number]';
          var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;

          module.exports = function isNumberObject(value) {
            if (typeof value === 'number') {
              return true;
            }

            if (typeof value !== 'object') {
              return false;
            }

            return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
          };
          /***/

        },

        /***/
        "./node_modules/is-regex/index.js": function node_modulesIsRegexIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var hasSymbols = __webpack_require__(
          /*! has-symbols */
          "./node_modules/has-symbols/index.js")();

          var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
          var hasOwnProperty;
          var regexExec;
          var isRegexMarker;
          var badStringifier;

          if (hasToStringTag) {
            hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
            regexExec = Function.call.bind(RegExp.prototype.exec);
            isRegexMarker = {};

            var throwRegexMarker = function throwRegexMarker() {
              throw isRegexMarker;
            };

            badStringifier = {
              toString: throwRegexMarker,
              valueOf: throwRegexMarker
            };

            if (typeof Symbol.toPrimitive === 'symbol') {
              badStringifier[Symbol.toPrimitive] = throwRegexMarker;
            }
          }

          var toStr = Object.prototype.toString;
          var gOPD = Object.getOwnPropertyDescriptor;
          var regexClass = '[object RegExp]';
          module.exports = hasToStringTag // eslint-disable-next-line consistent-return
          ? function isRegex(value) {
            if (!value || typeof value !== 'object') {
              return false;
            }

            var descriptor = gOPD(value, 'lastIndex');
            var hasLastIndexDataProperty = descriptor && hasOwnProperty(descriptor, 'value');

            if (!hasLastIndexDataProperty) {
              return false;
            }

            try {
              regexExec(value, badStringifier);
            } catch (e) {
              return e === isRegexMarker;
            }
          } : function isRegex(value) {
            // In older browsers, typeof regex incorrectly returns 'function'
            if (!value || typeof value !== 'object' && typeof value !== 'function') {
              return false;
            }

            return toStr.call(value) === regexClass;
          };
          /***/
        },

        /***/
        "./node_modules/is-set/index.js": function node_modulesIsSetIndexJs(module) {
          "use strict";

          var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
          var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
          var exported;

          if (!$Set) {
            // eslint-disable-next-line no-unused-vars
            exported = function isSet(x) {
              // `Set` is not present in this environment.
              return false;
            };
          }

          var $mapHas = $Map ? Map.prototype.has : null;
          var $setHas = $Set ? Set.prototype.has : null;

          if (!exported && !$setHas) {
            // eslint-disable-next-line no-unused-vars
            exported = function isSet(x) {
              // `Set` does not have a `has` method
              return false;
            };
          }

          module.exports = exported || function isSet(x) {
            if (!x || typeof x !== 'object') {
              return false;
            }

            try {
              $setHas.call(x);

              if ($mapHas) {
                try {
                  $mapHas.call(x);
                } catch (e) {
                  return true;
                }
              }

              return x instanceof $Set; // core-js workaround, pre-v2.5.0
            } catch (e) {}

            return false;
          };
          /***/

        },

        /***/
        "./node_modules/is-string/index.js": function node_modulesIsStringIndexJs(module) {
          "use strict";

          var strValue = String.prototype.valueOf;

          var tryStringObject = function tryStringObject(value) {
            try {
              strValue.call(value);
              return true;
            } catch (e) {
              return false;
            }
          };

          var toStr = Object.prototype.toString;
          var strClass = '[object String]';
          var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;

          module.exports = function isString(value) {
            if (typeof value === 'string') {
              return true;
            }

            if (typeof value !== 'object') {
              return false;
            }

            return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
          };
          /***/

        },

        /***/
        "./node_modules/is-symbol/index.js": function node_modulesIsSymbolIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var toStr = Object.prototype.toString;

          var hasSymbols = __webpack_require__(
          /*! has-symbols */
          "./node_modules/has-symbols/index.js")();

          if (hasSymbols) {
            var symToStr = Symbol.prototype.toString;
            var symStringRegex = /^Symbol\(.*\)$/;

            var isSymbolObject = function isRealSymbolObject(value) {
              if (typeof value.valueOf() !== 'symbol') {
                return false;
              }

              return symStringRegex.test(symToStr.call(value));
            };

            module.exports = function isSymbol(value) {
              if (typeof value === 'symbol') {
                return true;
              }

              if (toStr.call(value) !== '[object Symbol]') {
                return false;
              }

              try {
                return isSymbolObject(value);
              } catch (e) {
                return false;
              }
            };
          } else {
            module.exports = function isSymbol(value) {
              // this environment does not support Symbols.
              return false && 0;
            };
          }
          /***/

        },

        /***/
        "./node_modules/is-typed-array/index.js": function node_modulesIsTypedArrayIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var forEach = __webpack_require__(
          /*! foreach */
          "./node_modules/foreach/index.js");

          var availableTypedArrays = __webpack_require__(
          /*! available-typed-arrays */
          "./node_modules/available-typed-arrays/index.js");

          var callBound = __webpack_require__(
          /*! call-bind/callBound */
          "./node_modules/call-bind/callBound.js");

          var $toString = callBound('Object.prototype.toString');

          var hasSymbols = __webpack_require__(
          /*! has-symbols */
          "./node_modules/has-symbols/index.js")();

          var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
          var typedArrays = availableTypedArrays();

          var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
            for (var i = 0; i < array.length; i += 1) {
              if (array[i] === value) {
                return i;
              }
            }

            return -1;
          };

          var $slice = callBound('String.prototype.slice');
          var toStrTags = {};

          var gOPD = __webpack_require__(
          /*! es-abstract/helpers/getOwnPropertyDescriptor */
          "./node_modules/is-typed-array/node_modules/es-abstract/helpers/getOwnPropertyDescriptor.js");

          var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

          if (hasToStringTag && gOPD && getPrototypeOf) {
            forEach(typedArrays, function (typedArray) {
              var arr = new __webpack_require__.g[typedArray]();

              if (!(Symbol.toStringTag in arr)) {
                throw new EvalError('this engine has support for Symbol.toStringTag, but ' + typedArray + ' does not have the property! Please report this.');
              }

              var proto = getPrototypeOf(arr);
              var descriptor = gOPD(proto, Symbol.toStringTag);

              if (!descriptor) {
                var superProto = getPrototypeOf(proto);
                descriptor = gOPD(superProto, Symbol.toStringTag);
              }

              toStrTags[typedArray] = descriptor.get;
            });
          }

          var tryTypedArrays = function tryAllTypedArrays(value) {
            var anyTrue = false;
            forEach(toStrTags, function (getter, typedArray) {
              if (!anyTrue) {
                try {
                  anyTrue = getter.call(value) === typedArray;
                } catch (e) {
                  /**/
                }
              }
            });
            return anyTrue;
          };

          module.exports = function isTypedArray(value) {
            if (!value || typeof value !== 'object') {
              return false;
            }

            if (!hasToStringTag) {
              var tag = $slice($toString(value), 8, -1);
              return $indexOf(typedArrays, tag) > -1;
            }

            if (!gOPD) {
              return false;
            }

            return tryTypedArrays(value);
          };
          /***/

        },

        /***/
        "./node_modules/is-weakmap/index.js": function node_modulesIsWeakmapIndexJs(module) {
          "use strict";

          var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
          var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;
          var exported;

          if (!$WeakMap) {
            // eslint-disable-next-line no-unused-vars
            exported = function isWeakMap(x) {
              // `WeakMap` is not present in this environment.
              return false;
            };
          }

          var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
          var $setHas = $WeakSet ? $WeakSet.prototype.has : null;

          if (!exported && !$mapHas) {
            // eslint-disable-next-line no-unused-vars
            exported = function isWeakMap(x) {
              // `WeakMap` does not have a `has` method
              return false;
            };
          }

          module.exports = exported || function isWeakMap(x) {
            if (!x || typeof x !== 'object') {
              return false;
            }

            try {
              $mapHas.call(x, $mapHas);

              if ($setHas) {
                try {
                  $setHas.call(x, $setHas);
                } catch (e) {
                  return true;
                }
              }

              return x instanceof $WeakMap; // core-js workaround, pre-v3
            } catch (e) {}

            return false;
          };
          /***/

        },

        /***/
        "./node_modules/is-weakset/index.js": function node_modulesIsWeaksetIndexJs(module) {
          "use strict";

          var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
          var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;
          var exported;

          if (!$WeakMap) {
            // eslint-disable-next-line no-unused-vars
            exported = function isWeakSet(x) {
              // `WeakSet` is not present in this environment.
              return false;
            };
          }

          var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
          var $setHas = $WeakSet ? $WeakSet.prototype.has : null;

          if (!exported && !$setHas) {
            // eslint-disable-next-line no-unused-vars
            module.exports = function isWeakSet(x) {
              // `WeakSet` does not have a `has` method
              return false;
            };
          }

          module.exports = exported || function isWeakSet(x) {
            if (!x || typeof x !== 'object') {
              return false;
            }

            try {
              $setHas.call(x, $setHas);

              if ($mapHas) {
                try {
                  $mapHas.call(x, $mapHas);
                } catch (e) {
                  return true;
                }
              }

              return x instanceof $WeakSet; // core-js workaround, pre-v3
            } catch (e) {}

            return false;
          };
          /***/

        },

        /***/
        "./node_modules/object-is/implementation.js": function node_modulesObjectIsImplementationJs(module) {
          "use strict";

          var numberIsNaN = function numberIsNaN(value) {
            return value !== value;
          };

          module.exports = function is(a, b) {
            if (a === 0 && b === 0) {
              return 1 / a === 1 / b;
            }

            if (a === b) {
              return true;
            }

            if (numberIsNaN(a) && numberIsNaN(b)) {
              return true;
            }

            return false;
          };
          /***/

        },

        /***/
        "./node_modules/object-is/index.js": function node_modulesObjectIsIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var define = __webpack_require__(
          /*! define-properties */
          "./node_modules/define-properties/index.js");

          var callBind = __webpack_require__(
          /*! call-bind */
          "./node_modules/call-bind/index.js");

          var implementation = __webpack_require__(
          /*! ./implementation */
          "./node_modules/object-is/implementation.js");

          var getPolyfill = __webpack_require__(
          /*! ./polyfill */
          "./node_modules/object-is/polyfill.js");

          var shim = __webpack_require__(
          /*! ./shim */
          "./node_modules/object-is/shim.js");

          var polyfill = callBind(getPolyfill(), Object);
          define(polyfill, {
            getPolyfill: getPolyfill,
            implementation: implementation,
            shim: shim
          });
          module.exports = polyfill;
          /***/
        },

        /***/
        "./node_modules/object-is/polyfill.js": function node_modulesObjectIsPolyfillJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var implementation = __webpack_require__(
          /*! ./implementation */
          "./node_modules/object-is/implementation.js");

          module.exports = function getPolyfill() {
            return typeof Object.is === 'function' ? Object.is : implementation;
          };
          /***/

        },

        /***/
        "./node_modules/object-is/shim.js": function node_modulesObjectIsShimJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var getPolyfill = __webpack_require__(
          /*! ./polyfill */
          "./node_modules/object-is/polyfill.js");

          var define = __webpack_require__(
          /*! define-properties */
          "./node_modules/define-properties/index.js");

          module.exports = function shimObjectIs() {
            var polyfill = getPolyfill();
            define(Object, {
              is: polyfill
            }, {
              is: function testObjectIs() {
                return Object.is !== polyfill;
              }
            });
            return polyfill;
          };
          /***/

        },

        /***/
        "./node_modules/object-keys/implementation.js": function node_modulesObjectKeysImplementationJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var keysShim;

          if (!Object.keys) {
            // modified from https://github.com/es-shims/es5-shim
            var has = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;

            var isArgs = __webpack_require__(
            /*! ./isArguments */
            "./node_modules/object-keys/isArguments.js"); // eslint-disable-line global-require


            var isEnumerable = Object.prototype.propertyIsEnumerable;
            var hasDontEnumBug = !isEnumerable.call({
              toString: null
            }, 'toString');
            var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
            var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];

            var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
              var ctor = o.constructor;
              return ctor && ctor.prototype === o;
            };

            var excludedKeys = {
              $applicationCache: true,
              $console: true,
              $external: true,
              $frame: true,
              $frameElement: true,
              $frames: true,
              $innerHeight: true,
              $innerWidth: true,
              $onmozfullscreenchange: true,
              $onmozfullscreenerror: true,
              $outerHeight: true,
              $outerWidth: true,
              $pageXOffset: true,
              $pageYOffset: true,
              $parent: true,
              $scrollLeft: true,
              $scrollTop: true,
              $scrollX: true,
              $scrollY: true,
              $self: true,
              $webkitIndexedDB: true,
              $webkitStorageInfo: true,
              $window: true
            };

            var hasAutomationEqualityBug = function () {
              /* global window */
              if (typeof window === 'undefined') {
                return false;
              }

              for (var k in window) {
                try {
                  if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
                    try {
                      equalsConstructorPrototype(window[k]);
                    } catch (e) {
                      return true;
                    }
                  }
                } catch (e) {
                  return true;
                }
              }

              return false;
            }();

            var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
              /* global window */
              if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
                return equalsConstructorPrototype(o);
              }

              try {
                return equalsConstructorPrototype(o);
              } catch (e) {
                return false;
              }
            };

            keysShim = function keys(object) {
              var isObject = object !== null && typeof object === 'object';
              var isFunction = toStr.call(object) === '[object Function]';
              var isArguments = isArgs(object);
              var isString = isObject && toStr.call(object) === '[object String]';
              var theKeys = [];

              if (!isObject && !isFunction && !isArguments) {
                throw new TypeError('Object.keys called on a non-object');
              }

              var skipProto = hasProtoEnumBug && isFunction;

              if (isString && object.length > 0 && !has.call(object, 0)) {
                for (var i = 0; i < object.length; ++i) {
                  theKeys.push(String(i));
                }
              }

              if (isArguments && object.length > 0) {
                for (var j = 0; j < object.length; ++j) {
                  theKeys.push(String(j));
                }
              } else {
                for (var name in object) {
                  if (!(skipProto && name === 'prototype') && has.call(object, name)) {
                    theKeys.push(String(name));
                  }
                }
              }

              if (hasDontEnumBug) {
                var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

                for (var k = 0; k < dontEnums.length; ++k) {
                  if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
                    theKeys.push(dontEnums[k]);
                  }
                }
              }

              return theKeys;
            };
          }

          module.exports = keysShim;
          /***/
        },

        /***/
        "./node_modules/object-keys/index.js": function node_modulesObjectKeysIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var slice = Array.prototype.slice;

          var isArgs = __webpack_require__(
          /*! ./isArguments */
          "./node_modules/object-keys/isArguments.js");

          var origKeys = Object.keys;
          var keysShim = origKeys ? function keys(o) {
            return origKeys(o);
          } : __webpack_require__(
          /*! ./implementation */
          "./node_modules/object-keys/implementation.js");
          var originalKeys = Object.keys;

          keysShim.shim = function shimObjectKeys() {
            if (Object.keys) {
              var keysWorksWithArguments = function () {
                // Safari 5.0 bug
                var args = Object.keys(arguments);
                return args && args.length === arguments.length;
              }(1, 2);

              if (!keysWorksWithArguments) {
                Object.keys = function keys(object) {
                  // eslint-disable-line func-name-matching
                  if (isArgs(object)) {
                    return originalKeys(slice.call(object));
                  }

                  return originalKeys(object);
                };
              }
            } else {
              Object.keys = keysShim;
            }

            return Object.keys || keysShim;
          };

          module.exports = keysShim;
          /***/
        },

        /***/
        "./node_modules/object-keys/isArguments.js": function node_modulesObjectKeysIsArgumentsJs(module) {
          "use strict";

          var toStr = Object.prototype.toString;

          module.exports = function isArguments(value) {
            var str = toStr.call(value);
            var isArgs = str === '[object Arguments]';

            if (!isArgs) {
              isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
            }

            return isArgs;
          };
          /***/

        },

        /***/
        "./node_modules/object.assign/implementation.js": function node_modulesObjectAssignImplementationJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict"; // modified from https://github.com/es-shims/es6-shim

          var keys = __webpack_require__(
          /*! object-keys */
          "./node_modules/object-keys/index.js");

          var canBeObject = function canBeObject(obj) {
            return typeof obj !== 'undefined' && obj !== null;
          };

          var hasSymbols = __webpack_require__(
          /*! has-symbols/shams */
          "./node_modules/has-symbols/shams.js")();

          var callBound = __webpack_require__(
          /*! call-bind/callBound */
          "./node_modules/call-bind/callBound.js");

          var toObject = Object;
          var $push = callBound('Array.prototype.push');
          var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
          var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null; // eslint-disable-next-line no-unused-vars

          module.exports = function assign(target, source1) {
            if (!canBeObject(target)) {
              throw new TypeError('target must be an object');
            }

            var objTarget = toObject(target);
            var s, source, i, props, syms, value, key;

            for (s = 1; s < arguments.length; ++s) {
              source = toObject(arguments[s]);
              props = keys(source);
              var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);

              if (getSymbols) {
                syms = getSymbols(source);

                for (i = 0; i < syms.length; ++i) {
                  key = syms[i];

                  if ($propIsEnumerable(source, key)) {
                    $push(props, key);
                  }
                }
              }

              for (i = 0; i < props.length; ++i) {
                key = props[i];
                value = source[key];

                if ($propIsEnumerable(source, key)) {
                  objTarget[key] = value;
                }
              }
            }

            return objTarget;
          };
          /***/

        },

        /***/
        "./node_modules/object.assign/index.js": function node_modulesObjectAssignIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var defineProperties = __webpack_require__(
          /*! define-properties */
          "./node_modules/define-properties/index.js");

          var callBind = __webpack_require__(
          /*! call-bind */
          "./node_modules/call-bind/index.js");

          var implementation = __webpack_require__(
          /*! ./implementation */
          "./node_modules/object.assign/implementation.js");

          var getPolyfill = __webpack_require__(
          /*! ./polyfill */
          "./node_modules/object.assign/polyfill.js");

          var shim = __webpack_require__(
          /*! ./shim */
          "./node_modules/object.assign/shim.js");

          var polyfill = callBind.apply(getPolyfill()); // eslint-disable-next-line no-unused-vars

          var bound = function assign(target, source1) {
            return polyfill(Object, arguments);
          };

          defineProperties(bound, {
            getPolyfill: getPolyfill,
            implementation: implementation,
            shim: shim
          });
          module.exports = bound;
          /***/
        },

        /***/
        "./node_modules/object.assign/polyfill.js": function node_modulesObjectAssignPolyfillJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var implementation = __webpack_require__(
          /*! ./implementation */
          "./node_modules/object.assign/implementation.js");

          var lacksProperEnumerationOrder = function lacksProperEnumerationOrder() {
            if (!Object.assign) {
              return false;
            }
            /*
             * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
             * note: this does not detect the bug unless there's 20 characters
             */


            var str = 'abcdefghijklmnopqrst';
            var letters = str.split('');
            var map = {};

            for (var i = 0; i < letters.length; ++i) {
              map[letters[i]] = letters[i];
            }

            var obj = Object.assign({}, map);
            var actual = '';

            for (var k in obj) {
              actual += k;
            }

            return str !== actual;
          };

          var assignHasPendingExceptions = function assignHasPendingExceptions() {
            if (!Object.assign || !Object.preventExtensions) {
              return false;
            }
            /*
             * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
             * which is 72% slower than our shim, and Firefox 40's native implementation.
             */


            var thrower = Object.preventExtensions({
              1: 2
            });

            try {
              Object.assign(thrower, 'xy');
            } catch (e) {
              return thrower[1] === 'y';
            }

            return false;
          };

          module.exports = function getPolyfill() {
            if (!Object.assign) {
              return implementation;
            }

            if (lacksProperEnumerationOrder()) {
              return implementation;
            }

            if (assignHasPendingExceptions()) {
              return implementation;
            }

            return Object.assign;
          };
          /***/

        },

        /***/
        "./node_modules/object.assign/shim.js": function node_modulesObjectAssignShimJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var define = __webpack_require__(
          /*! define-properties */
          "./node_modules/define-properties/index.js");

          var getPolyfill = __webpack_require__(
          /*! ./polyfill */
          "./node_modules/object.assign/polyfill.js");

          module.exports = function shimAssign() {
            var polyfill = getPolyfill();
            define(Object, {
              assign: polyfill
            }, {
              assign: function assign() {
                return Object.assign !== polyfill;
              }
            });
            return polyfill;
          };
          /***/

        },

        /***/
        "./node_modules/regexp.prototype.flags/implementation.js": function node_modulesRegexpPrototypeFlagsImplementationJs(module) {
          "use strict";

          var $Object = Object;
          var $TypeError = TypeError;

          module.exports = function flags() {
            if (this != null && this !== $Object(this)) {
              throw new $TypeError('RegExp.prototype.flags getter called on non-object');
            }

            var result = '';

            if (this.global) {
              result += 'g';
            }

            if (this.ignoreCase) {
              result += 'i';
            }

            if (this.multiline) {
              result += 'm';
            }

            if (this.dotAll) {
              result += 's';
            }

            if (this.unicode) {
              result += 'u';
            }

            if (this.sticky) {
              result += 'y';
            }

            return result;
          };
          /***/

        },

        /***/
        "./node_modules/regexp.prototype.flags/index.js": function node_modulesRegexpPrototypeFlagsIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var define = __webpack_require__(
          /*! define-properties */
          "./node_modules/define-properties/index.js");

          var callBind = __webpack_require__(
          /*! call-bind */
          "./node_modules/call-bind/index.js");

          var implementation = __webpack_require__(
          /*! ./implementation */
          "./node_modules/regexp.prototype.flags/implementation.js");

          var getPolyfill = __webpack_require__(
          /*! ./polyfill */
          "./node_modules/regexp.prototype.flags/polyfill.js");

          var shim = __webpack_require__(
          /*! ./shim */
          "./node_modules/regexp.prototype.flags/shim.js");

          var flagsBound = callBind(implementation);
          define(flagsBound, {
            getPolyfill: getPolyfill,
            implementation: implementation,
            shim: shim
          });
          module.exports = flagsBound;
          /***/
        },

        /***/
        "./node_modules/regexp.prototype.flags/polyfill.js": function node_modulesRegexpPrototypeFlagsPolyfillJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var implementation = __webpack_require__(
          /*! ./implementation */
          "./node_modules/regexp.prototype.flags/implementation.js");

          var supportsDescriptors = __webpack_require__(
          /*! define-properties */
          "./node_modules/define-properties/index.js").supportsDescriptors;

          var $gOPD = Object.getOwnPropertyDescriptor;
          var $TypeError = TypeError;

          module.exports = function getPolyfill() {
            if (!supportsDescriptors) {
              throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
            }

            if (/a/mig.flags === 'gim') {
              var descriptor = $gOPD(RegExp.prototype, 'flags');

              if (descriptor && typeof descriptor.get === 'function' && typeof /a/.dotAll === 'boolean') {
                return descriptor.get;
              }
            }

            return implementation;
          };
          /***/

        },

        /***/
        "./node_modules/regexp.prototype.flags/shim.js": function node_modulesRegexpPrototypeFlagsShimJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var supportsDescriptors = __webpack_require__(
          /*! define-properties */
          "./node_modules/define-properties/index.js").supportsDescriptors;

          var getPolyfill = __webpack_require__(
          /*! ./polyfill */
          "./node_modules/regexp.prototype.flags/polyfill.js");

          var gOPD = Object.getOwnPropertyDescriptor;
          var defineProperty = Object.defineProperty;
          var TypeErr = TypeError;
          var getProto = Object.getPrototypeOf;
          var regex = /a/;

          module.exports = function shimFlags() {
            if (!supportsDescriptors || !getProto) {
              throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
            }

            var polyfill = getPolyfill();
            var proto = getProto(regex);
            var descriptor = gOPD(proto, 'flags');

            if (!descriptor || descriptor.get !== polyfill) {
              defineProperty(proto, 'flags', {
                configurable: true,
                enumerable: false,
                get: polyfill
              });
            }

            return polyfill;
          };
          /***/

        },

        /***/
        "./node_modules/side-channel/index.js": function node_modulesSideChannelIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var GetIntrinsic = __webpack_require__(
          /*! get-intrinsic */
          "./node_modules/get-intrinsic/index.js");

          var callBound = __webpack_require__(
          /*! call-bind/callBound */
          "./node_modules/call-bind/callBound.js");

          var inspect = __webpack_require__(
          /*! object-inspect */
          "./node_modules/side-channel/node_modules/object-inspect/index.js");

          var $TypeError = GetIntrinsic('%TypeError%');
          var $WeakMap = GetIntrinsic('%WeakMap%', true);
          var $Map = GetIntrinsic('%Map%', true);
          var $weakMapGet = callBound('WeakMap.prototype.get', true);
          var $weakMapSet = callBound('WeakMap.prototype.set', true);
          var $weakMapHas = callBound('WeakMap.prototype.has', true);
          var $mapGet = callBound('Map.prototype.get', true);
          var $mapSet = callBound('Map.prototype.set', true);
          var $mapHas = callBound('Map.prototype.has', true);
          /*
           * This function traverses the list returning the node corresponding to the
           * given key.
           *
           * That node is also moved to the head of the list, so that if it's accessed
           * again we don't need to traverse the whole list. By doing so, all the recently
           * used nodes can be accessed relatively quickly.
           */

          var listGetNode = function listGetNode(list, key) {
            // eslint-disable-line consistent-return
            for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
              if (curr.key === key) {
                prev.next = curr.next;
                curr.next = list.next;
                list.next = curr; // eslint-disable-line no-param-reassign

                return curr;
              }
            }
          };

          var listGet = function listGet(objects, key) {
            var node = listGetNode(objects, key);
            return node && node.value;
          };

          var listSet = function listSet(objects, key, value) {
            var node = listGetNode(objects, key);

            if (node) {
              node.value = value;
            } else {
              // Prepend the new node to the beginning of the list
              objects.next = {
                // eslint-disable-line no-param-reassign
                key: key,
                next: objects.next,
                value: value
              };
            }
          };

          var listHas = function listHas(objects, key) {
            return !!listGetNode(objects, key);
          };

          module.exports = function getSideChannel() {
            var $wm;
            var $m;
            var $o;
            var channel = {
              assert: function assert(key) {
                if (!channel.has(key)) {
                  throw new $TypeError('Side channel does not contain ' + inspect(key));
                }
              },
              get: function get(key) {
                // eslint-disable-line consistent-return
                if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                  if ($wm) {
                    return $weakMapGet($wm, key);
                  }
                } else if ($Map) {
                  if ($m) {
                    return $mapGet($m, key);
                  }
                } else {
                  if ($o) {
                    // eslint-disable-line no-lonely-if
                    return listGet($o, key);
                  }
                }
              },
              has: function has(key) {
                if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                  if ($wm) {
                    return $weakMapHas($wm, key);
                  }
                } else if ($Map) {
                  if ($m) {
                    return $mapHas($m, key);
                  }
                } else {
                  if ($o) {
                    // eslint-disable-line no-lonely-if
                    return listHas($o, key);
                  }
                }

                return false;
              },
              set: function set(key, value) {
                if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                  if (!$wm) {
                    $wm = new $WeakMap();
                  }

                  $weakMapSet($wm, key, value);
                } else if ($Map) {
                  if (!$m) {
                    $m = new $Map();
                  }

                  $mapSet($m, key, value);
                } else {
                  if (!$o) {
                    /*
                     * Initialize the linked list as an empty node, so that we don't have
                     * to special-case handling of the first node: we can always refer to
                     * it as (previous node).next, instead of something like (list).head
                     */
                    $o = {
                      key: {},
                      next: null
                    };
                  }

                  listSet($o, key, value);
                }
              }
            };
            return channel;
          };
          /***/

        },

        /***/
        "./node_modules/side-channel/node_modules/object-inspect/index.js": function node_modulesSideChannelNode_modulesObjectInspectIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          var hasMap = typeof Map === 'function' && Map.prototype;
          var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
          var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
          var mapForEach = hasMap && Map.prototype.forEach;
          var hasSet = typeof Set === 'function' && Set.prototype;
          var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
          var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
          var setForEach = hasSet && Set.prototype.forEach;
          var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
          var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
          var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
          var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
          var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
          var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
          var booleanValueOf = Boolean.prototype.valueOf;
          var objectToString = Object.prototype.toString;
          var functionToString = Function.prototype.toString;
          var match = String.prototype.match;
          var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
          var gOPS = Object.getOwnPropertySymbols;
          var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
          var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
          var isEnumerable = Object.prototype.propertyIsEnumerable;
          var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
          ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
          } : null);

          var inspectCustom = __webpack_require__(
          /*! ./util.inspect */
          "?b1b0").custom;

          var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
          var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

          module.exports = function inspect_(obj, options, depth, seen) {
            var opts = options || {};

            if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
              throw new TypeError('option "quoteStyle" must be "single" or "double"');
            }

            if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
              throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
            }

            var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;

            if (typeof customInspect !== 'boolean') {
              throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
            }

            if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
              throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
            }

            if (typeof obj === 'undefined') {
              return 'undefined';
            }

            if (obj === null) {
              return 'null';
            }

            if (typeof obj === 'boolean') {
              return obj ? 'true' : 'false';
            }

            if (typeof obj === 'string') {
              return inspectString(obj, opts);
            }

            if (typeof obj === 'number') {
              if (obj === 0) {
                return Infinity / obj > 0 ? '0' : '-0';
              }

              return String(obj);
            }

            if (typeof obj === 'bigint') {
              return String(obj) + 'n';
            }

            var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;

            if (typeof depth === 'undefined') {
              depth = 0;
            }

            if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
              return isArray(obj) ? '[Array]' : '[Object]';
            }

            var indent = getIndent(opts, depth);

            if (typeof seen === 'undefined') {
              seen = [];
            } else if (indexOf(seen, obj) >= 0) {
              return '[Circular]';
            }

            function inspect(value, from, noIndent) {
              if (from) {
                seen = seen.slice();
                seen.push(from);
              }

              if (noIndent) {
                var newOpts = {
                  depth: opts.depth
                };

                if (has(opts, 'quoteStyle')) {
                  newOpts.quoteStyle = opts.quoteStyle;
                }

                return inspect_(value, newOpts, depth + 1, seen);
              }

              return inspect_(value, opts, depth + 1, seen);
            }

            if (typeof obj === 'function') {
              var name = nameOf(obj);
              var keys = arrObjKeys(obj, inspect);
              return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
            }

            if (isSymbol(obj)) {
              var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
              return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
            }

            if (isElement(obj)) {
              var s = '<' + String(obj.nodeName).toLowerCase();
              var attrs = obj.attributes || [];

              for (var i = 0; i < attrs.length; i++) {
                s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
              }

              s += '>';

              if (obj.childNodes && obj.childNodes.length) {
                s += '...';
              }

              s += '</' + String(obj.nodeName).toLowerCase() + '>';
              return s;
            }

            if (isArray(obj)) {
              if (obj.length === 0) {
                return '[]';
              }

              var xs = arrObjKeys(obj, inspect);

              if (indent && !singleLineValues(xs)) {
                return '[' + indentedJoin(xs, indent) + ']';
              }

              return '[ ' + xs.join(', ') + ' ]';
            }

            if (isError(obj)) {
              var parts = arrObjKeys(obj, inspect);

              if (parts.length === 0) {
                return '[' + String(obj) + ']';
              }

              return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
            }

            if (typeof obj === 'object' && customInspect) {
              if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
                return obj[inspectSymbol]();
              } else if (typeof obj.inspect === 'function') {
                return obj.inspect();
              }
            }

            if (isMap(obj)) {
              var mapParts = [];
              mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
              });
              return collectionOf('Map', mapSize.call(obj), mapParts, indent);
            }

            if (isSet(obj)) {
              var setParts = [];
              setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
              });
              return collectionOf('Set', setSize.call(obj), setParts, indent);
            }

            if (isWeakMap(obj)) {
              return weakCollectionOf('WeakMap');
            }

            if (isWeakSet(obj)) {
              return weakCollectionOf('WeakSet');
            }

            if (isWeakRef(obj)) {
              return weakCollectionOf('WeakRef');
            }

            if (isNumber(obj)) {
              return markBoxed(inspect(Number(obj)));
            }

            if (isBigInt(obj)) {
              return markBoxed(inspect(bigIntValueOf.call(obj)));
            }

            if (isBoolean(obj)) {
              return markBoxed(booleanValueOf.call(obj));
            }

            if (isString(obj)) {
              return markBoxed(inspect(String(obj)));
            }

            if (!isDate(obj) && !isRegExp(obj)) {
              var ys = arrObjKeys(obj, inspect);
              var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
              var protoTag = obj instanceof Object ? '' : 'null prototype';
              var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
              var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
              var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');

              if (ys.length === 0) {
                return tag + '{}';
              }

              if (indent) {
                return tag + '{' + indentedJoin(ys, indent) + '}';
              }

              return tag + '{ ' + ys.join(', ') + ' }';
            }

            return String(obj);
          };

          function wrapQuotes(s, defaultStyle, opts) {
            var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
            return quoteChar + s + quoteChar;
          }

          function quote(s) {
            return String(s).replace(/"/g, '&quot;');
          }

          function isArray(obj) {
            return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
          }

          function isDate(obj) {
            return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
          }

          function isRegExp(obj) {
            return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
          }

          function isError(obj) {
            return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
          }

          function isString(obj) {
            return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
          }

          function isNumber(obj) {
            return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
          }

          function isBoolean(obj) {
            return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
          } // Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives


          function isSymbol(obj) {
            if (hasShammedSymbols) {
              return obj && typeof obj === 'object' && obj instanceof Symbol;
            }

            if (typeof obj === 'symbol') {
              return true;
            }

            if (!obj || typeof obj !== 'object' || !symToString) {
              return false;
            }

            try {
              symToString.call(obj);
              return true;
            } catch (e) {}

            return false;
          }

          function isBigInt(obj) {
            if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
              return false;
            }

            try {
              bigIntValueOf.call(obj);
              return true;
            } catch (e) {}

            return false;
          }

          var hasOwn = Object.prototype.hasOwnProperty || function (key) {
            return key in this;
          };

          function has(obj, key) {
            return hasOwn.call(obj, key);
          }

          function toStr(obj) {
            return objectToString.call(obj);
          }

          function nameOf(f) {
            if (f.name) {
              return f.name;
            }

            var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);

            if (m) {
              return m[1];
            }

            return null;
          }

          function indexOf(xs, x) {
            if (xs.indexOf) {
              return xs.indexOf(x);
            }

            for (var i = 0, l = xs.length; i < l; i++) {
              if (xs[i] === x) {
                return i;
              }
            }

            return -1;
          }

          function isMap(x) {
            if (!mapSize || !x || typeof x !== 'object') {
              return false;
            }

            try {
              mapSize.call(x);

              try {
                setSize.call(x);
              } catch (s) {
                return true;
              }

              return x instanceof Map; // core-js workaround, pre-v2.5.0
            } catch (e) {}

            return false;
          }

          function isWeakMap(x) {
            if (!weakMapHas || !x || typeof x !== 'object') {
              return false;
            }

            try {
              weakMapHas.call(x, weakMapHas);

              try {
                weakSetHas.call(x, weakSetHas);
              } catch (s) {
                return true;
              }

              return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
            } catch (e) {}

            return false;
          }

          function isWeakRef(x) {
            if (!weakRefDeref || !x || typeof x !== 'object') {
              return false;
            }

            try {
              weakRefDeref.call(x);
              return true;
            } catch (e) {}

            return false;
          }

          function isSet(x) {
            if (!setSize || !x || typeof x !== 'object') {
              return false;
            }

            try {
              setSize.call(x);

              try {
                mapSize.call(x);
              } catch (m) {
                return true;
              }

              return x instanceof Set; // core-js workaround, pre-v2.5.0
            } catch (e) {}

            return false;
          }

          function isWeakSet(x) {
            if (!weakSetHas || !x || typeof x !== 'object') {
              return false;
            }

            try {
              weakSetHas.call(x, weakSetHas);

              try {
                weakMapHas.call(x, weakMapHas);
              } catch (s) {
                return true;
              }

              return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
            } catch (e) {}

            return false;
          }

          function isElement(x) {
            if (!x || typeof x !== 'object') {
              return false;
            }

            if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
              return true;
            }

            return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
          }

          function inspectString(str, opts) {
            if (str.length > opts.maxStringLength) {
              var remaining = str.length - opts.maxStringLength;
              var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
              return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
            } // eslint-disable-next-line no-control-regex


            var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
            return wrapQuotes(s, 'single', opts);
          }

          function lowbyte(c) {
            var n = c.charCodeAt(0);
            var x = {
              8: 'b',
              9: 't',
              10: 'n',
              12: 'f',
              13: 'r'
            }[n];

            if (x) {
              return '\\' + x;
            }

            return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
          }

          function markBoxed(str) {
            return 'Object(' + str + ')';
          }

          function weakCollectionOf(type) {
            return type + ' { ? }';
          }

          function collectionOf(type, size, entries, indent) {
            var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
            return type + ' (' + size + ') {' + joinedEntries + '}';
          }

          function singleLineValues(xs) {
            for (var i = 0; i < xs.length; i++) {
              if (indexOf(xs[i], '\n') >= 0) {
                return false;
              }
            }

            return true;
          }

          function getIndent(opts, depth) {
            var baseIndent;

            if (opts.indent === '\t') {
              baseIndent = '\t';
            } else if (typeof opts.indent === 'number' && opts.indent > 0) {
              baseIndent = Array(opts.indent + 1).join(' ');
            } else {
              return null;
            }

            return {
              base: baseIndent,
              prev: Array(depth + 1).join(baseIndent)
            };
          }

          function indentedJoin(xs, indent) {
            if (xs.length === 0) {
              return '';
            }

            var lineJoiner = '\n' + indent.prev + indent.base;
            return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
          }

          function arrObjKeys(obj, inspect) {
            var isArr = isArray(obj);
            var xs = [];

            if (isArr) {
              xs.length = obj.length;

              for (var i = 0; i < obj.length; i++) {
                xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
              }
            }

            var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
            var symMap;

            if (hasShammedSymbols) {
              symMap = {};

              for (var k = 0; k < syms.length; k++) {
                symMap['$' + syms[k]] = syms[k];
              }
            }

            for (var key in obj) {
              // eslint-disable-line no-restricted-syntax
              if (!has(obj, key)) {
                continue;
              } // eslint-disable-line no-restricted-syntax, no-continue


              if (isArr && String(Number(key)) === key && key < obj.length) {
                continue;
              } // eslint-disable-line no-restricted-syntax, no-continue


              if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
                // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
                continue; // eslint-disable-line no-restricted-syntax, no-continue
              } else if (/[^\w$]/.test(key)) {
                xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
              } else {
                xs.push(key + ': ' + inspect(obj[key], obj));
              }
            }

            if (typeof gOPS === 'function') {
              for (var j = 0; j < syms.length; j++) {
                if (isEnumerable.call(obj, syms[j])) {
                  xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
                }
              }
            }

            return xs;
          }
          /***/

        },

        /***/
        "./src/ClientContext.ts": function srcClientContextTs(__unused_webpack_module, exports, __webpack_require__) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });

          var react_1 = __webpack_require__(
          /*! react */
          "react");

          var ClientContext = (0, react_1.createContext)(undefined);
          exports["default"] = ClientContext;
          /***/
        },

        /***/
        "./src/Provider.tsx": function srcProviderTsx(__unused_webpack_module, exports, __webpack_require__) {
          "use strict";

          var __importDefault = this && this.__importDefault || function (mod) {
            return mod && mod.__esModule ? mod : {
              "default": mod
            };
          };

          Object.defineProperty(exports, "__esModule", {
            value: true
          });

          var react_1 = __importDefault(__webpack_require__(
          /*! react */
          "react"));

          var ClientContext_1 = __importDefault(__webpack_require__(
          /*! ./ClientContext */
          "./src/ClientContext.ts"));

          var useClient_1 = __importDefault(__webpack_require__(
          /*! ./useClient */
          "./src/useClient.ts"));

          function ClientProvider(_ref) {
            var children = _ref.children,
                props = _objectWithoutProperties(_ref, _excluded);

            var client = (0, useClient_1.default)(props);

            if (!client) {
              return null;
            }

            return react_1.default.createElement(ClientContext_1.default.Provider, {
              value: client
            }, children);
          }

          exports["default"] = ClientProvider;
          /***/
        },

        /***/
        "./src/index.tsx": function srcIndexTsx(__unused_webpack_module, exports, __webpack_require__) {
          "use strict";

          var __importDefault = this && this.__importDefault || function (mod) {
            return mod && mod.__esModule ? mod : {
              "default": mod
            };
          };

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports["default"] = exports.useSubscription = exports.useClient = exports.ClientContext = void 0;

          var ClientContext_1 = __webpack_require__(
          /*! ./ClientContext */
          "./src/ClientContext.ts");

          Object.defineProperty(exports, "ClientContext", {
            enumerable: true,
            get: function get() {
              return __importDefault(ClientContext_1).default;
            }
          });

          var useClient_1 = __webpack_require__(
          /*! ./useClient */
          "./src/useClient.ts");

          Object.defineProperty(exports, "useClient", {
            enumerable: true,
            get: function get() {
              return __importDefault(useClient_1).default;
            }
          });

          var useSubscription_1 = __webpack_require__(
          /*! ./useSubscription */
          "./src/useSubscription.ts");

          Object.defineProperty(exports, "useSubscription", {
            enumerable: true,
            get: function get() {
              return __importDefault(useSubscription_1).default;
            }
          });

          var Provider_1 = __webpack_require__(
          /*! ./Provider */
          "./src/Provider.tsx");

          Object.defineProperty(exports, "default", {
            enumerable: true,
            get: function get() {
              return __importDefault(Provider_1).default;
            }
          });
          /***/
        },

        /***/
        "./src/useClient.ts": function srcUseClientTs(__unused_webpack_module, exports, __webpack_require__) {
          "use strict";

          var __importDefault = this && this.__importDefault || function (mod) {
            return mod && mod.__esModule ? mod : {
              "default": mod
            };
          };

          Object.defineProperty(exports, "__esModule", {
            value: true
          });

          var react_1 = __webpack_require__(
          /*! react */
          "react");

          var deep_equal_1 = __importDefault(__webpack_require__(
          /*! deep-equal */
          "./node_modules/deep-equal/index.js"));

          var streamr_client_1 = __webpack_require__(
          /*! streamr-client */
          "streamr-client");

          var ClientContext_1 = __importDefault(__webpack_require__(
          /*! ./ClientContext */
          "./src/ClientContext.ts"));

          var EMPTY_CONFIG = {};
          var isSSR = typeof window === 'undefined';

          function getNewClient(config) {
            if (config === EMPTY_CONFIG || isSSR) {
              return undefined;
            }

            return new streamr_client_1.StreamrClient(config);
          }

          function useClient() {
            var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_CONFIG;
            var configRef = (0, react_1.useRef)(config);
            var parentClient = (0, react_1.useContext)(ClientContext_1.default);

            var _ref2 = (0, react_1.useState)(function () {
              return getNewClient(config);
            }),
                _ref3 = _slicedToArray(_ref2, 2),
                client = _ref3[0],
                setClient = _ref3[1];

            (0, react_1.useEffect)(function () {
              if (config === EMPTY_CONFIG) {
                // Leaving `config` out means we're gonna use the provided client.
                return;
              }

              if ((0, deep_equal_1.default)(configRef.current, config)) {
                // Configuration hasn't changed. We don't need a new StreamrClient instance.
                return;
              }

              configRef.current = config;
              setClient(getNewClient(config));
            }, [config]);
            (0, react_1.useEffect)(function () {
              return function () {
                client === null || client === void 0 ? void 0 : client.destroy();
              };
            }, [client]);
            return client || parentClient;
          }

          exports["default"] = useClient;
          /***/
        },

        /***/
        "./src/useIsMounted.ts": function srcUseIsMountedTs(__unused_webpack_module, exports, __webpack_require__) {
          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });

          var react_1 = __webpack_require__(
          /*! react */
          "react");

          exports["default"] = function () {
            var ref = (0, react_1.useRef)(true);
            (0, react_1.useEffect)(function () {
              return function () {
                ref.current = false;
              };
            }, []);
            return (0, react_1.useCallback)(function () {
              return ref.current;
            }, []);
          };
          /***/

        },

        /***/
        "./src/useSubscription.ts": function srcUseSubscriptionTs(__unused_webpack_module, exports, __webpack_require__) {
          "use strict";

          var __importDefault = this && this.__importDefault || function (mod) {
            return mod && mod.__esModule ? mod : {
              "default": mod
            };
          };

          Object.defineProperty(exports, "__esModule", {
            value: true
          });

          var react_1 = __webpack_require__(
          /*! react */
          "react");

          var deep_equal_1 = __importDefault(__webpack_require__(
          /*! deep-equal */
          "./node_modules/deep-equal/index.js"));

          var useClient_1 = __importDefault(__webpack_require__(
          /*! ./useClient */
          "./src/useClient.ts"));

          var useIsMounted_1 = __importDefault(__webpack_require__(
          /*! ./useIsMounted */
          "./src/useIsMounted.ts"));

          var defaultErrorHandler = function defaultErrorHandler(error) {
            console.error(error);
          };

          var noop = function noop() {};

          function useSubscription(subscriptionParams) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var _options$isActive = options.isActive,
                isActive = _options$isActive === void 0 ? true : _options$isActive,
                _options$onMessage = options.onMessage,
                onMessage = _options$onMessage === void 0 ? noop : _options$onMessage,
                _options$onSubscribed = options.onSubscribed,
                onSubscribed = _options$onSubscribed === void 0 ? noop : _options$onSubscribed,
                _options$onError = options.onError,
                onError = _options$onError === void 0 ? defaultErrorHandler : _options$onError;

            var _ref4 = (0, react_1.useState)(subscriptionParams),
                _ref5 = _slicedToArray(_ref4, 2),
                params = _ref5[0],
                setParams = _ref5[1];

            var client = (0, useClient_1.default)();
            (0, react_1.useEffect)(function () {
              if ((0, deep_equal_1.default)(params, subscriptionParams)) {
                // Subscription params haven't changed. Skipping the rest.
                return;
              }

              setParams(subscriptionParams);
            }, [params, subscriptionParams]);
            var isMounted = (0, useIsMounted_1.default)();
            var onMessageRef = (0, react_1.useRef)(onMessage);
            (0, react_1.useEffect)(function () {
              onMessageRef.current = onMessage;
            }, [onMessage]);
            var onErrorRef = (0, react_1.useRef)(onError);
            (0, react_1.useEffect)(function () {
              onErrorRef.current = onError;
            }, [onError]);
            var onSubscribedRef = (0, react_1.useRef)(onSubscribed);
            (0, react_1.useEffect)(function () {
              onSubscribedRef.current = onSubscribed;
            }, [onSubscribed]);

            var _ref6 = (0, react_1.useState)(),
                _ref7 = _slicedToArray(_ref6, 2),
                subscription = _ref7[0],
                setSubscription = _ref7[1];

            (0, react_1.useEffect)(function () {
              var cancelled = false;

              if (!client || client.isDestroyed()) {
                // Unusable client instance. Nothing to do.
                return;
              }

              if (!isActive) {
                // Inactive = free to skip.
                return;
              }

              var sub = undefined;

              function unsub() {
                sub === null || sub === void 0 ? void 0 : sub.unsubscribe().catch(function () {});
                sub = undefined;
              }

              function shouldSub() {
                return !cancelled && isMounted() && !client.isDestroyed();
              }

              function subscribe() {
                return _subscribe.apply(this, arguments);
              }

              function _subscribe() {
                _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;

                          if (shouldSub()) {
                            _context.next = 3;
                            break;
                          }

                          return _context.abrupt("return");

                        case 3:
                          _context.next = 5;
                          return client.subscribe(subscriptionParams, function (message, raw) {
                            if (typeof onMessageRef.current === 'function') {
                              onMessageRef.current(message, raw);
                            }
                          });

                        case 5:
                          sub = _context.sent;

                          if (shouldSub()) {
                            _context.next = 9;
                            break;
                          }

                          unsub();
                          return _context.abrupt("return");

                        case 9:
                          setSubscription(sub);
                          _context.next = 15;
                          break;

                        case 12:
                          _context.prev = 12;
                          _context.t0 = _context["catch"](0);
                          onErrorRef.current(_context.t0);

                        case 15:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 12]]);
                }));
                return _subscribe.apply(this, arguments);
              }

              subscribe();
              return function () {
                cancelled = true;
                unsub();
              };
            }, [isActive, params, client, isMounted]);
            (0, react_1.useEffect)(function () {
              if (!subscription) {
                return;
              }

              if (typeof onSubscribedRef.current === 'function') {
                onSubscribedRef.current();
              }
            }, [subscription]);
          }

          exports["default"] = useSubscription;
          /***/
        },

        /***/
        "./node_modules/which-boxed-primitive/index.js": function node_modulesWhichBoxedPrimitiveIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var isString = __webpack_require__(
          /*! is-string */
          "./node_modules/is-string/index.js");

          var isNumber = __webpack_require__(
          /*! is-number-object */
          "./node_modules/is-number-object/index.js");

          var isBoolean = __webpack_require__(
          /*! is-boolean-object */
          "./node_modules/is-boolean-object/index.js");

          var isSymbol = __webpack_require__(
          /*! is-symbol */
          "./node_modules/is-symbol/index.js");

          var isBigInt = __webpack_require__(
          /*! is-bigint */
          "./node_modules/is-bigint/index.js"); // eslint-disable-next-line consistent-return


          module.exports = function whichBoxedPrimitive(value) {
            // eslint-disable-next-line eqeqeq
            if (value == null || typeof value !== 'object' && typeof value !== 'function') {
              return null;
            }

            if (isString(value)) {
              return 'String';
            }

            if (isNumber(value)) {
              return 'Number';
            }

            if (isBoolean(value)) {
              return 'Boolean';
            }

            if (isSymbol(value)) {
              return 'Symbol';
            }

            if (isBigInt(value)) {
              return 'BigInt';
            }
          };
          /***/

        },

        /***/
        "./node_modules/which-typed-array/index.js": function node_modulesWhichTypedArrayIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var forEach = __webpack_require__(
          /*! foreach */
          "./node_modules/foreach/index.js");

          var availableTypedArrays = __webpack_require__(
          /*! available-typed-arrays */
          "./node_modules/available-typed-arrays/index.js");

          var callBound = __webpack_require__(
          /*! call-bind/callBound */
          "./node_modules/call-bind/callBound.js");

          var $toString = callBound('Object.prototype.toString');

          var hasSymbols = __webpack_require__(
          /*! has-symbols */
          "./node_modules/has-symbols/index.js")();

          var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
          var typedArrays = availableTypedArrays();
          var $slice = callBound('String.prototype.slice');
          var toStrTags = {};

          var gOPD = __webpack_require__(
          /*! es-abstract/helpers/getOwnPropertyDescriptor */
          "./node_modules/which-typed-array/node_modules/es-abstract/helpers/getOwnPropertyDescriptor.js");

          var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

          if (hasToStringTag && gOPD && getPrototypeOf) {
            forEach(typedArrays, function (typedArray) {
              if (typeof __webpack_require__.g[typedArray] === 'function') {
                var arr = new __webpack_require__.g[typedArray]();

                if (!(Symbol.toStringTag in arr)) {
                  throw new EvalError('this engine has support for Symbol.toStringTag, but ' + typedArray + ' does not have the property! Please report this.');
                }

                var proto = getPrototypeOf(arr);
                var descriptor = gOPD(proto, Symbol.toStringTag);

                if (!descriptor) {
                  var superProto = getPrototypeOf(proto);
                  descriptor = gOPD(superProto, Symbol.toStringTag);
                }

                toStrTags[typedArray] = descriptor.get;
              }
            });
          }

          var tryTypedArrays = function tryAllTypedArrays(value) {
            var foundName = false;
            forEach(toStrTags, function (getter, typedArray) {
              if (!foundName) {
                try {
                  var name = getter.call(value);

                  if (name === typedArray) {
                    foundName = name;
                  }
                } catch (e) {}
              }
            });
            return foundName;
          };

          var isTypedArray = __webpack_require__(
          /*! is-typed-array */
          "./node_modules/is-typed-array/index.js");

          module.exports = function whichTypedArray(value) {
            if (!isTypedArray(value)) {
              return false;
            }

            if (!hasToStringTag) {
              return $slice($toString(value), 8, -1);
            }

            return tryTypedArrays(value);
          };
          /***/

        },

        /***/
        "react": function react(module) {
          "use strict";

          module.exports = __WEBPACK_EXTERNAL_MODULE_react__;
          /***/
        },

        /***/
        "streamr-client": function streamrClient(module) {
          "use strict";

          module.exports = __WEBPACK_EXTERNAL_MODULE_streamr_client__;
          /***/
        },

        /***/
        "?b1b0": function b1b0() {
          /* (ignored) */

          /***/
        },

        /***/
        "./node_modules/available-typed-arrays/index.js": function node_modulesAvailableTypedArraysIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var possibleNames = ['BigInt64Array', 'BigUint64Array', 'Float32Array', 'Float64Array', 'Int16Array', 'Int32Array', 'Int8Array', 'Uint16Array', 'Uint32Array', 'Uint8Array', 'Uint8ClampedArray'];

          module.exports = function availableTypedArrays() {
            var out = [];

            for (var i = 0; i < possibleNames.length; i++) {
              if (typeof __webpack_require__.g[possibleNames[i]] === 'function') {
                out[out.length] = possibleNames[i];
              }
            }

            return out;
          };
          /***/

        },

        /***/
        "./node_modules/es-get-iterator/index.js": function node_modulesEsGetIteratorIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";
          /* eslint global-require: 0 */
          // the code is structured this way so that bundlers can
          // alias out `has-symbols` to `() => true` or `() => false` if your target
          // environments' Symbol capabilities are known, and then use
          // dead code elimination on the rest of this module.
          //
          // Similarly, `isarray` can be aliased to `Array.isArray` if
          // available in all target environments.

          var isArguments = __webpack_require__(
          /*! is-arguments */
          "./node_modules/is-arguments/index.js");

          if (__webpack_require__(
          /*! has-symbols */
          "./node_modules/has-symbols/index.js")() || __webpack_require__(
          /*! has-symbols/shams */
          "./node_modules/has-symbols/shams.js")()) {
            var $iterator = Symbol.iterator; // Symbol is available natively or shammed
            // natively:
            //  - Chrome >= 38
            //  - Edge 12-14?, Edge >= 15 for sure
            //  - FF >= 36
            //  - Safari >= 9
            //  - node >= 0.12

            module.exports = function getIterator(iterable) {
              // alternatively, `iterable[$iterator]?.()`
              if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
                return iterable[$iterator]();
              }

              if (isArguments(iterable)) {
                // arguments objects lack Symbol.iterator
                // - node 0.12
                return Array.prototype[$iterator].call(iterable);
              }
            };
          } else {
            // Symbol is not available, native or shammed
            var isArray = __webpack_require__(
            /*! isarray */
            "./node_modules/es-get-iterator/node_modules/isarray/index.js");

            var isString = __webpack_require__(
            /*! is-string */
            "./node_modules/is-string/index.js");

            var GetIntrinsic = __webpack_require__(
            /*! get-intrinsic */
            "./node_modules/get-intrinsic/index.js");

            var $Map = GetIntrinsic('%Map%', true);
            var $Set = GetIntrinsic('%Set%', true);

            var callBound = __webpack_require__(
            /*! call-bind/callBound */
            "./node_modules/call-bind/callBound.js");

            var $arrayPush = callBound('Array.prototype.push');
            var $charCodeAt = callBound('String.prototype.charCodeAt');
            var $stringSlice = callBound('String.prototype.slice');

            var advanceStringIndex = function advanceStringIndex(S, index) {
              var length = S.length;

              if (index + 1 >= length) {
                return index + 1;
              }

              var first = $charCodeAt(S, index);

              if (first < 0xD800 || first > 0xDBFF) {
                return index + 1;
              }

              var second = $charCodeAt(S, index + 1);

              if (second < 0xDC00 || second > 0xDFFF) {
                return index + 1;
              }

              return index + 2;
            };

            var getArrayIterator = function getArrayIterator(arraylike) {
              var i = 0;
              return {
                next: function next() {
                  var done = i >= arraylike.length;
                  var value;

                  if (!done) {
                    value = arraylike[i];
                    i += 1;
                  }

                  return {
                    done: done,
                    value: value
                  };
                }
              };
            };

            var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
              if (isArray(iterable) || isArguments(iterable)) {
                return getArrayIterator(iterable);
              }

              if (isString(iterable)) {
                var i = 0;
                return {
                  next: function next() {
                    var nextIndex = advanceStringIndex(iterable, i);
                    var value = $stringSlice(iterable, i, nextIndex);
                    i = nextIndex;
                    return {
                      done: nextIndex > iterable.length,
                      value: value
                    };
                  }
                };
              } // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.


              if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
                return iterable['_es6-shim iterator_']();
              }
            };

            if (!$Map && !$Set) {
              // the only language iterables are Array, String, arguments
              // - Safari <= 6.0
              // - Chrome < 38
              // - node < 0.12
              // - FF < 13
              // - IE < 11
              // - Edge < 11
              module.exports = function getIterator(iterable) {
                if (iterable != null) {
                  return getNonCollectionIterator(iterable, true);
                }
              };
            } else {
              // either Map or Set are available, but Symbol is not
              // - es6-shim on an ES5 browser
              // - Safari 6.2 (maybe 6.1?)
              // - FF v[13, 36)
              // - IE 11
              // - Edge 11
              // - Safari v[6, 9)
              var isMap = __webpack_require__(
              /*! is-map */
              "./node_modules/is-map/index.js");

              var isSet = __webpack_require__(
              /*! is-set */
              "./node_modules/is-set/index.js"); // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach


              var $mapForEach = callBound('Map.prototype.forEach', true);
              var $setForEach = callBound('Set.prototype.forEach', true);

              if (typeof process === 'undefined' || !process.versions || !process.versions.node) {
                // "if is not node"
                // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
                // returns a value, or throws a StopIteration object. These browsers
                // do not have any other mechanism for iteration.
                var $mapIterator = callBound('Map.prototype.iterator', true);
                var $setIterator = callBound('Set.prototype.iterator', true);

                var getStopIterationIterator = function getStopIterationIterator(iterator) {
                  var done = false;
                  return {
                    next: function next() {
                      try {
                        return {
                          done: done,
                          value: done ? undefined : iterator.next()
                        };
                      } catch (e) {
                        done = true;
                        return {
                          done: true,
                          value: undefined
                        };
                      }
                    }
                  };
                };
              } // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
              // this returns a proper iterator object, so we should use it instead of forEach.
              // newer es6-shim versions use a string "_es6-shim iterator_" property.


              var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
              var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);

              var getCollectionIterator = function getCollectionIterator(iterable) {
                if (isMap(iterable)) {
                  if ($mapIterator) {
                    return getStopIterationIterator($mapIterator(iterable));
                  }

                  if ($mapAtAtIterator) {
                    return $mapAtAtIterator(iterable);
                  }

                  if ($mapForEach) {
                    var entries = [];
                    $mapForEach(iterable, function (v, k) {
                      $arrayPush(entries, [k, v]);
                    });
                    return getArrayIterator(entries);
                  }
                }

                if (isSet(iterable)) {
                  if ($setIterator) {
                    return getStopIterationIterator($setIterator(iterable));
                  }

                  if ($setAtAtIterator) {
                    return $setAtAtIterator(iterable);
                  }

                  if ($setForEach) {
                    var values = [];
                    $setForEach(iterable, function (v) {
                      $arrayPush(values, v);
                    });
                    return getArrayIterator(values);
                  }
                }
              };

              module.exports = function getIterator(iterable) {
                return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
              };
            }
          }
          /***/

        },

        /***/
        "./node_modules/is-typed-array/node_modules/es-abstract/helpers/getOwnPropertyDescriptor.js": function node_modulesIsTypedArrayNode_modulesEsAbstractHelpersGetOwnPropertyDescriptorJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var GetIntrinsic = __webpack_require__(
          /*! get-intrinsic */
          "./node_modules/get-intrinsic/index.js");

          var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%');

          if ($gOPD) {
            try {
              $gOPD([], 'length');
            } catch (e) {
              // IE 8 has a broken gOPD
              $gOPD = null;
            }
          }

          module.exports = $gOPD;
          /***/
        },

        /***/
        "./node_modules/which-collection/index.js": function node_modulesWhichCollectionIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var isMap = __webpack_require__(
          /*! is-map */
          "./node_modules/is-map/index.js");

          var isSet = __webpack_require__(
          /*! is-set */
          "./node_modules/is-set/index.js");

          var isWeakMap = __webpack_require__(
          /*! is-weakmap */
          "./node_modules/is-weakmap/index.js");

          var isWeakSet = __webpack_require__(
          /*! is-weakset */
          "./node_modules/is-weakset/index.js");

          module.exports = function whichCollection(value) {
            if (value && typeof value === 'object') {
              if (isMap(value)) {
                return 'Map';
              }

              if (isSet(value)) {
                return 'Set';
              }

              if (isWeakMap(value)) {
                return 'WeakMap';
              }

              if (isWeakSet(value)) {
                return 'WeakSet';
              }
            }

            return false;
          };
          /***/

        },

        /***/
        "./node_modules/which-typed-array/node_modules/es-abstract/helpers/getOwnPropertyDescriptor.js": function node_modulesWhichTypedArrayNode_modulesEsAbstractHelpersGetOwnPropertyDescriptorJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var GetIntrinsic = __webpack_require__(
          /*! get-intrinsic */
          "./node_modules/get-intrinsic/index.js");

          var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%');

          if ($gOPD) {
            try {
              $gOPD([], 'length');
            } catch (e) {
              // IE 8 has a broken gOPD
              $gOPD = null;
            }
          }

          module.exports = $gOPD;
          /***/
        }
        /******/

      };
      /************************************************************************/

      /******/
      // The module cache

      /******/

      var __webpack_module_cache__ = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/
        // Check if module is in cache

        /******/
        var cachedModule = __webpack_module_cache__[moduleId];
        /******/

        if (cachedModule !== undefined) {
          /******/
          return cachedModule.exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = __webpack_module_cache__[moduleId] = {
          /******/
          // no module.id needed

          /******/
          // no module.loaded needed

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Return the exports of the module

        /******/


        return module.exports;
        /******/
      }
      /******/

      /************************************************************************/

      /******/

      /* webpack/runtime/global */

      /******/


      (function () {
        /******/
        __webpack_require__.g = function () {
          /******/
          if (typeof globalThis === 'object') return globalThis;
          /******/

          try {
            /******/
            return this || new Function('return this')();
            /******/
          } catch (e) {
            /******/
            if (typeof window === 'object') return window;
            /******/
          }
          /******/

        }();
        /******/

      })();
      /******/

      /************************************************************************/

      /******/

      /******/
      // startup

      /******/
      // Load entry module and return exports

      /******/
      // This entry module is referenced by other modules so it can't be inlined

      /******/


      var __webpack_exports__ = __webpack_require__("./src/index.tsx");
      /******/

      /******/


      return __webpack_exports__;
      /******/
    }()
  );
});